/* tslint:disable:max-line-length */
/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

export const FurnitureIcon: React.SFC = () => {
    return (
        <svg width="46" height="46" viewBox="0 0 46 46" xmlns="http://www.w3.org/2000/svg">
            <title>Icon / furniture</title>
            <g fillRule="nonzero" fill="#FCA61B">
                <path d="M4 18l38-.064v-1.872L4 16v2zm39-3v4H3v-4h40z" />
                <path d="M40 19v12H6V19h34zm1-1H5v14h36V18z" />
                <path d="M21 22v6H9v-6h12zm1-1H8v8h14v-8z" />
                <path d="M18 24h-6v1h6M16 25h-2v1h2M37 22v6H25v-6h12zm1-1H24v8h14v-8z" />
                <path d="M34 24h-6v1h6M32 25h-2v1h2M37 32v5h-1v-5h1zm1-1h-3v7h3v-7zM10 32v5H9v-5h1zm1-1H8v7h3v-7zM27 12v3h-5v-3h5zm1-1h-7v5h7v-5zM35 9v6h-5V9h5zm1-1h-7v8h7V8zM40 9v6h-2V9h2zm1-1h-4v8h4V8z" />
                <path d="M41 11h-4v1h4" />
            </g>
        </svg>
    )
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/images/icons/AssetsIcons/Furniture.tsx